import { CellContext } from '@tanstack/react-table';
import { QueryKey } from '@tanstack/react-query';
import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import TagsCell from '@/components/table/_fieldDefinitions/tags/TagsCell.tsx';

export interface TagsCellContext {
  targetType?: TaggableType;
  queryKey?: QueryKey;
}

export const tagsFieldRender = <T,>(
  info: CellContext<T, unknown>,
  customFieldsContext?: TagsCellContext,
) => {
  const tags = (info.getValue() as TagWebDto[] | undefined) ?? [];
  const targetId = (info.row.original as { id?: string }).id;

  return (
    <TagsCell
      tags={tags}
      targetType={customFieldsContext?.targetType}
      targetId={targetId}
      queryKey={customFieldsContext?.queryKey}
    />
  );
};
